import classNames from 'classnames';
import React from 'react';

import styles from './AppModal.module.scss';

export default function AppModal({ children, open, setOpen }) {
  React.useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
    }
  }, [open]);

  return (
    // eslint-disable-next-line
    <div
      onClick={() => setOpen(false)}
      className={classNames(styles.Overlay, {
        // eslint-disable-next-line
        [styles['Overlay--Show']]: open,
      })}>
      <div onClick={(e) => e.stopPropagation()} className={styles.Modal}>
        {children}
      </div>
    </div>
  );
}
